import React, { useRef } from 'react';
import { styled } from '@compiled/react';
import { DropdownItem, type DropdownItemProps } from '@atlaskit/dropdown-menu';
import type { CustomItemComponentProps } from '@atlaskit/menu/types';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MeatballMenuItemLink } from '@atlassian/jira-issue-navigator-meatball-menu-item-link/src/index.tsx';
import { Link, type LinkProps } from '@atlassian/react-resource-router';

type RouteLinkItemOldProps = LinkProps &
	DropdownItemProps & {
		className?: string;
		name?: string;
		role?: string;
		id?: string;
		rel?: string;
		styleClass?: string;
		onClick: () => void;
	};

export const RouteLinkItemOld = ({
	rel,
	target,
	styleClass,
	onClick,
	name,
	...props
}: RouteLinkItemOldProps): React.JSX.Element => {
	const webItemLinkRef = useRef<HTMLAnchorElement>(null);
	const onClickWebItem = (e: React.MouseEvent | React.KeyboardEvent) => {
		if (webItemLinkRef.current?.classList.contains('ap-dialog')) {
			e.preventDefault();
			webItemLinkRef.current?.click();
		}

		onClick();
	};
	return (
		<>
			<DropdownItem
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				component={Link as React.ComponentType<CustomItemComponentProps>}
				rel={(rel ?? target === '_blank') ? 'noopener noreferrer' : ''}
				target={target}
				prefetch="hover"
				onClick={onClickWebItem}
				{...props}
			/>

			{/**
			 * We are replacing this implementation with MeatballMenuItemLink
			 * This is a very outdated style. Class name on this element
			 * will be used by another script to attach event listeners and
			 * open this plug-in into a modal.
			 */}
			{styleClass && (
				<HiddenLink
					ref={webItemLinkRef}
					href={props.href}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styleClass}
				>
					{name}
				</HiddenLink>
			)}
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HiddenLink = styled.a({
	display: 'none',
});

export const RouteLinkItem = componentWithCondition(
	() => fg('nin_trigger_connect_webitem_dialog'),
	MeatballMenuItemLink,
	RouteLinkItemOld,
);
